export default {
  fabCategory: {
    bottom: 100
  },
  fabUnit: {

  }
};
